import axios from 'axios'
import { getRequestHead } from './header.js'
import { getToken } from './auth'
import store from '@/store'
import Toast from '@/components/toast/index'
import Loading from '@/components/loading/index'

const header = getRequestHead()
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30 * 1000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    const token = getToken()
    // eslint-disable-next-line no-prototype-builtins
    if (token && token.length > 0 && !header.hasOwnProperty('Authorization')) {
      header.Authorization = 'Bearer ' + token
      console.log('get token direct')
    }
    config.headers = {...header}
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 0) {
      console.log(res)
      // 33002: Token expired; 33003: Illegal token;
      // 34001: Illegal user openid;  340012 Illegal user name or password; 34003: Other clients logged in;
      if (res.code === 20001 || res.code === 20002 || res.code === 20003 || res.code === 20004 || res.code === 20005 ) {
        Loading.$hideLoading()
        Toast.$toast('请重新登录')
        store.dispatch('global/setToken', '')
        return res
      }
      Loading.$hideLoading()
      Toast.$toast(res.msg)
      return res
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Loading.$hideLoading()
    Toast.$toast(error.message)
  }
)

export default service
